// extracted by mini-css-extract-plugin
export default {"contentContainer":"SendReceiptContent_contentContainer__oWMkE","spinContainer":"SendReceiptContent_spinContainer__dgCs5"};